import type { LocaleBundle } from '../types.js'

export const pl: LocaleBundle = {
  code: 'pl',
  name: 'Polski',
  dict: {
    'common:appName': 'Modern Admin',
    'common:home': 'Strona główna',
    'common:search': 'Szukaj',
    'common:loading': 'Ładowanie…',
    'common:save': 'Zapisz',
    'common:cancel': 'Anuluj',
    'common:delete': 'Usuń',
    'common:create': 'Utwórz',
    'common:edit': 'Edytuj',
    'common:show': 'Pokaż',
    'common:back': 'Wstecz',
    'common:noRecords': 'Nie znaleziono rekordów.',
    'common:noRecordsHint': 'Zacznij od utworzenia nowego rekordu „{resource}".',
    'common:noMatchingRecords': 'Żaden rekord nie pasuje do filtrów.',
    'common:clearFilters': 'Wyczyść filtry',
    'common:confirmDelete': 'Usunąć ten rekord?',
    'common:confirmAction': 'Potwierdź akcję',
    'common:confirm': 'Potwierdź',
    'common:perPage': 'Na stronę',
    'common:page': 'Strona',
    'common:of': 'z',
    'common:total': 'Razem',
    'auth:login': 'Zaloguj się',
    'auth:logout': 'Wyloguj się',
    'auth:email': 'Email',
    'auth:password': 'Hasło',
    'auth:loginFailed': 'Nieprawidłowe dane logowania.',
    'errors:notFound': 'Nie znaleziono.',
    'errors:forbidden': 'Brak dostępu do tego zasobu.',
    'errors:server': 'Coś poszło nie tak. Spróbuj ponownie.',
    'common:resources': 'Zasoby',
    'common:actions': 'Akcje',
    'action:notFound': 'Akcja „{action}” jest niedostępna dla tego zasobu.',
    'action:componentMissing': 'Nie zarejestrowano komponentu o nazwie „{component}”.',
    'action:componentMissingHint': 'Zarejestruj go w ComponentLoaderze przekazywanym do <ModernAdminProvider components={…}>.',
    'action:loadFailed': 'Nie udało się wczytać akcji.',
    'common:new': 'Nowy',
    'common:rowsPerPage': 'Wierszy na stronę',
    'common:filter': 'Filtruj {label}…',
    'validation:required': 'Pole {label} jest wymagane',
    'validation:invalidNumber': 'Pole {label} musi być prawidłową liczbą',
    'validation:invalidInteger': 'Pole {label} musi być liczbą całkowitą',
    'validation:invalidEmail': 'Pole {label} musi być prawidłowym e-mailem',
    'validation:invalidUrl': 'Pole {label} musi być prawidłowym URL-em',
    'validation:invalidDate': 'Pole {label} musi być prawidłową datą',
    'validation:invalidUuid': 'Pole {label} musi być prawidłowym UUID',
    'validation:tooShort': 'Pole {label} musi mieć co najmniej {min} znaków',
    'validation:tooLong': 'Pole {label} może mieć co najwyżej {max} znaków',
    'validation:notInList': 'Pole {label} ma nieprawidłową wartość',
    'validation:emptySelection': 'Wybierz co najmniej jedną wartość dla {label}',
    'toast:created': 'Pomyślnie utworzono',
    'toast:saved': 'Pomyślnie zapisano',
    'toast:deleted': 'Pomyślnie usunięto',
    'toast:createFailed': 'Tworzenie nie powiodło się',
    'toast:saveFailed': 'Zapis nie powiódł się',
    'toast:deleteFailed': 'Usuwanie nie powiodło się',
    'toast:loadFailed': 'Wczytywanie nie powiodło się',
    'toast:validationFailed': 'Popraw błędy i spróbuj ponownie',
    'common:close': 'Zamknij',
    'common:export': 'Eksport',
    'export:title': 'Eksport rekordów',
    'export:description': 'Pobierz wszystkie pasujące rekordy zasobu {resource} w jednym pliku.',
    'export:csvHint': 'Wartości oddzielone przecinkami',
    'export:jsonHint': 'Strukturalna tablica JSON',
    'export:downloading': 'Przygotowywanie pobierania…',
    'export:progress': 'Wczytano {loaded} z {total}…',
    'export:exported': 'Wyeksportowano rekordów: {count}',
    'export:exportFailed': 'Nie udało się wyeksportować rekordów',
    'common:apply': 'Zastosuj',
    'common:clear': 'Wyczyść',
    'common:filters': 'Filtry',
    'common:columns': 'Kolumny',
    'common:toggleColumns': 'Pokaż kolumny',
    'common:openMenu': 'Otwórz menu',
    'common:refresh': 'Odśwież',
    'common:copy': 'Kopiuj',
    'common:copied': 'Skopiowano!',
    'common:applyFilters': 'Zastosuj filtry',
    'common:clearAll': 'Wyczyść wszystko',
    'common:any': 'Dowolne',
    'common:yes': 'Tak',
    'common:no': 'Nie',
    'common:filterPlaceholder': 'Filtruj…',
    'common:loadFailed': 'Błąd ładowania: {error}',
    'common:theme': 'Motyw',
    'common:language': 'Język',
    'common:toggleTheme': 'Zmień motyw',
    'common:clearSelection': 'Wyczyść wybór',
    'common:searchPlaceholder': 'Szukaj…',
    'home:searchResources': 'Szukaj zasobów…',
    'home:noMatchingResources': 'Nie znaleziono pasujących zasobów.',
    'globalSearch:title': 'Wyszukiwanie globalne',
    'globalSearch:description': 'Wyszukaj we wszystkich zasobach i rekordach.',
    'globalSearch:trigger': 'Szukaj…',
    'globalSearch:placeholder': 'Szukaj we wszystkich zasobach…',
    'globalSearch:hint': 'Zacznij pisać, aby przeszukać wszystkie zasoby.',
    'globalSearch:noResults': 'Nie znaleziono pasujących rekordów.',
    'globalSearch:error': 'Wyszukiwanie nie powiodło się. Spróbuj ponownie.',
    'globalSearch:hotkey': 'Otwórz wyszukiwanie globalne',
    'globalSearch:matchedIn': 'w {field}',
    'globalSearch:recent': 'Ostatnie wyszukiwania',
    'globalSearch:clearRecent': 'Wyczyść',
    'globalSearch:showAllIn': 'Pokaż wszystko w {resource}',
    'common:pageOf': 'Strona {page} z {total}',
    'common:firstPage': 'Pierwsza strona',
    'common:previousPage': 'Poprzednia strona',
    'common:nextPage': 'Następna strona',
    'common:lastPage': 'Ostatnia strona',
    'common:recordsCount': 'Rekordów: {count}',
    'common:selectedCount': 'Wybrano: {count}',
    'common:selectRow': 'Zaznacz wiersz',
    'common:selectAll': 'Zaznacz wszystkie',
    'common:deleteSelected': 'Usuń zaznaczone',
    'common:bulkDeleteConfirm': 'Usunąć {count} zaznaczonych rekordów?',
    'toast:bulkDeleted': 'Usunięto rekordów: {count}',
    'toast:bulkDeleteFailed': 'Nie udało się usunąć rekordów',
    'common:from': 'Od',
    'common:to': 'Do',
    'common:sortBy': 'Sortuj według',
    'common:next': 'Dalej',
    'common:previous': 'Wstecz',
    'common:relatedRecords': 'Powiązane rekordy',
    'common:viewAll': 'Zobacz wszystkie',
    'common:noRelatedRecords': 'Brak powiązanych rekordów.',
    'common:preview': 'Podgląd',
    'common:download': 'Pobierz',
    'common:openInNewTab': 'Otwórz w nowej karcie',
    'common:format': 'Sformatuj',
    'common:invalidJson': 'Nieprawidłowy JSON',
    'common:showPassword': 'Pokaż hasło',
    'common:hidePassword': 'Ukryj hasło',
    'common:shortcutsHelp': 'Skróty klawiszowe',
    'common:shortcutsEmpty': 'Brak skrótów dostępnych na tym ekranie.',
    'auth:title': 'Zaloguj się',
    'auth:subtitle': 'Podaj email i hasło, aby się zalogować',
    'auth:tagline': 'Nowoczesny panel administracyjny dla każdego stosu.',
    'auth:orContinueWith': 'Lub kontynuuj przez',
    'auth:continueWith': 'Kontynuuj przez {provider}',
    'common:chooseFile': 'Wybierz plik',
    'common:chooseFiles': 'Wybierz pliki',
    'common:dragAndDrop': 'Przeciągnij i upuść lub',
    'common:chooseAFile': 'wybierz plik',
    'common:addMoreFiles': 'dodaj kolejne pliki',
    'common:uploading': 'Przesyłanie…',
    'common:uploadingFile': 'Przesyłanie {name}…',
    'common:removeFile': 'Usuń plik',
    'common:uploadFailed': 'Przesyłanie nie powiodło się',
    'common:dismiss': 'Zamknij',
    'common:openCalendar': 'Otwórz kalendarz',
    'common:time': 'Godzina',
    'common:downloadFailed': 'Pobieranie nie powiodło się',
    'richtext:bold': 'Pogrubienie',
    'richtext:italic': 'Kursywa',
    'richtext:strikethrough': 'Przekreślenie',
    'richtext:inlineCode': 'Kod wbudowany',
    'richtext:heading': 'Nagłówek {level}',
    'richtext:bulletList': 'Lista punktowana',
    'richtext:numberedList': 'Lista numerowana',
    'richtext:blockquote': 'Cytat blokowy',
    'richtext:horizontalRule': 'Linia pozioma',
    'richtext:insertLink': 'Wstaw link',
    'richtext:undo': 'Cofnij',
    'richtext:redo': 'Ponów',
    'richtext:source': 'Źródło ({format})',
    'richtext:splitView': 'Widok podzielony',
    'richtext:visualEditor': 'Edytor wizualny',
    'richtext:fullscreen': 'Pełny ekran',
    'richtext:exitFullscreen': 'Wyjdź z pełnego ekranu',
    'richtext:urlPrompt': 'URL',
    'common:saving': 'Zapisywanie…',
    'common:done': 'Gotowe',
    'settings:menuItem': 'Ustawienia',
    'settings:noSectionsConfigured': 'Dla tego wdrożenia nie są dostępne żadne sekcje ustawień.',
    'settings:apiKeys.title': 'Klucze API',
    'settings:apiKeys.description': 'Tokeny programowego dostępu do API administracyjnego. Każdy klucz ma zestaw uprawnień ograniczający, jakie zasoby i akcje może wywołać.',
    'settings:apiKeys.actions.create': 'Nowy klucz',
    'settings:apiKeys.actions.edit': 'Edytuj',
    'settings:apiKeys.actions.revoke': 'Odwołaj',
    'settings:apiKeys.empty.title': 'Brak kluczy API',
    'settings:apiKeys.empty.description': 'Utwórz pierwszy klucz, aby przyznać dostęp programowy.',
    'settings:apiKeys.columns.name': 'Nazwa',
    'settings:apiKeys.columns.start': 'Prefiks',
    'settings:apiKeys.columns.permissions': 'Uprawnienia',
    'settings:apiKeys.columns.expiresAt': 'Wygasa',
    'settings:apiKeys.columns.enabled': 'Aktywny',
    'settings:apiKeys.columns.actions': 'Akcje',
    'settings:apiKeys.lastUsed': 'Ostatnio użyty {date}',
    'settings:apiKeys.expiresNever': 'Nigdy',
    'settings:apiKeys.permissions.resource': 'Zasób',
    'settings:apiKeys.permissions.actions': 'Akcje',
    'settings:apiKeys.permissions.selectAll': 'Zaznacz wszystkie',
    'settings:apiKeys.permissions.clearAll': 'Wyczyść wszystkie',
    'settings:apiKeys.permissions.none': 'Brak uprawnień',
    'settings:apiKeys.permissions.summary': '{resources} zasobów · {actions} akcji',
    'settings:apiKeys.permissions.noResources': 'Brak zarejestrowanych zasobów.',
    'settings:apiKeys.permissions.selectAllResources': 'Zaznacz wszystkie zasoby i akcje',
    'settings:apiKeys.permissions.clearAllResources': 'Wyczyść wszystkie zasoby i akcje',
    'settings:apiKeys.editor.titleCreate': 'Nowy klucz API',
    'settings:apiKeys.editor.titleEdit': 'Edytuj klucz API',
    'settings:apiKeys.editor.description': 'Wybierz opisową nazwę i nadaj tylko te zasoby i akcje, których ten klucz naprawdę potrzebuje.',
    'settings:apiKeys.editor.name': 'Nazwa',
    'settings:apiKeys.editor.namePlaceholder': 'np. bot wdrożeniowy CI',
    'settings:apiKeys.editor.expiresInDays': 'Wygasa za (dni)',
    'settings:apiKeys.editor.expiresPlaceholder': 'nigdy',
    'settings:apiKeys.editor.expiresHint': 'Pozostaw puste, aby klucz nie wygasał. Maksymalnie 3650 dni.',
    'settings:apiKeys.editor.permissions': 'Uprawnienia',
    'settings:apiKeys.editor.selectedActions': 'Zaznaczonych: {count}',
    'settings:apiKeys.created.title': 'Klucz API utworzony',
    'settings:apiKeys.created.description': 'Skopiuj klucz teraz — nie zostanie pokazany ponownie.',
    'settings:apiKeys.created.warning': 'To jedyny raz, kiedy zobaczysz pełny klucz. Przechowuj go w bezpiecznym miejscu.',
    'settings:apiKeys.created.reveal': 'Pokaż klucz',
    'settings:apiKeys.created.hide': 'Ukryj klucz',
    'settings:apiKeys.created.copy': 'Kopiuj',
    'settings:apiKeys.created.copied': 'Skopiowano',
    'settings:apiKeys.notice.revoked': 'Klucz API odwołany',
    'settings:apiKeys.notice.updated': 'Klucz API zaktualizowany',
    'settings:apiKeys.notice.copied': 'Skopiowano do schowka',
    'settings:apiKeys.notice.copyFailed': 'Nie udało się skopiować do schowka',
    'settings:apiKeys.confirmRevoke.title': 'Odwołaj klucz API',
    'settings:apiKeys.confirmRevoke.description': 'Odwołać „{name}"? Każda usługa korzystająca z tego klucza natychmiast przestanie działać.',
    'settings:webhooks.title': 'Webhooks',
    'settings:webhooks.description': 'Send signed HTTP notifications when records are created, updated, or deleted.',
    'settings:webhooks.actions.create': 'New webhook',
    'settings:webhooks.actions.test': 'Test',
    'settings:webhooks.notice.saved': 'Webhook saved',
    'settings:webhooks.notice.deleted': 'Webhook deleted',
    'settings:webhooks.notice.testQueued': 'Test notification queued',
    'settings:webhooks.confirmDelete.title': 'Delete webhook',
    'settings:webhooks.confirmDelete.description': 'Delete "{name}"? Delivery history for this webhook will also be removed.',
    'settings:webhooks.empty.title': 'No webhooks yet',
    'settings:webhooks.empty.description': 'Create a webhook to notify external systems about admin changes.',
    'settings:webhooks.columns.name': 'Name',
    'settings:webhooks.columns.resource': 'Resource',
    'settings:webhooks.columns.events': 'Events',
    'settings:webhooks.columns.enabled': 'Enabled',
    'settings:webhooks.columns.actions': 'Actions',
    'settings:webhooks.deliveries.title': 'Recent deliveries',
    'settings:webhooks.deliveries.status': 'Status',
    'settings:webhooks.deliveries.event': 'Event',
    'settings:webhooks.deliveries.attempt': 'Attempt',
    'settings:webhooks.deliveries.response': 'Response',
    'settings:webhooks.deliveries.createdAt': 'Created',
    'settings:webhooks.editor.titleCreate': 'New webhook',
    'settings:webhooks.editor.titleEdit': 'Edit webhook',
    'settings:webhooks.editor.description': 'Choose target URL, events, filters, and optional payload projection.',
    'settings:webhooks.editor.name': 'Name',
    'settings:webhooks.editor.url': 'URL',
    'settings:webhooks.editor.resource': 'Resource',
    'settings:webhooks.editor.allResources': 'All resources',
    'settings:webhooks.editor.secret': 'Signing secret',
    'settings:webhooks.editor.enabled': 'Enabled',
    'settings:webhooks.editor.events': 'Events',
    'settings:webhooks.editor.payloadFields': 'Payload fields',
    'settings:webhooks.editor.payloadFieldsHint': 'Restrict the payload to specific fields. Leave all unchecked to include the full record. Useful to avoid sending sensitive columns.',
    'settings:webhooks.editor.headers': 'Headers',
    'settings:webhooks.editor.headersHint': 'Custom HTTP headers sent with every delivery.\n\nExample:\n{\n  "Authorization": "Bearer <token>",\n  "X-Source": "modern-admin"\n}\n\nUseful for auth tokens, Slack incoming webhook URLs stored as a header, or endpoint-specific signatures.',
    'settings:webhooks.editor.filters': 'Filters',
    'settings:webhooks.editor.filtersHint': 'Deliver only when the record matches all conditions (AND semantics). Leave empty to deliver for every matching event.\n\nExample:\n{\n  "status": "published",\n  "role": "admin"\n}\n\nNote: delete events bypass field filters because the record no longer exists.',
    'settings:webhooks.editor.secretHint': 'Random string used to sign each delivery with HMAC-SHA256. Verify the X-Webhook-Signature header on your server to ensure the request is genuine.',
    'chart:dashboard': 'Panel',
    'chart:addChart': 'Dodaj wykres',
    'chart:newChart': 'Nowy wykres',
    'chart:editChart': 'Edytuj wykres',
    'chart:deleteChart': 'Usuń wykres',
    'chart:noCharts': 'Brak wykresów',
    'chart:noChartsHint': 'Dodaj wykres, aby zacząć monitorować dane.',
    'chart:addGroup': 'Dodaj grupę',
    'chart:newGroup': 'Nowa grupa',
    'chart:editGroup': 'Edytuj grupę',
    'chart:deleteGroup': 'Usuń grupę',
    'chart:saveGroup': 'Zapisz grupę',
    'chart:groupName': 'Nazwa grupy',
    'chart:groupNamePlaceholder': 'np. Metryki sprzedaży',
    'chart:groupNameRequired': 'Nazwa grupy jest wymagana',
    'chart:groupOrder': 'Kolejność grupy',
    'chart:order': 'Kolejność',
    'chart:orderHint': 'Niższe wartości są wyświetlane jako pierwsze.',
    'chart:moveToGroup': 'Przenieś do grupy',
    'chart:moveChart': 'Przenieś wykres',
    'chart:moveGroup': 'Grupa',
    'chart:moveNoGroups': 'Brak grup.',
    'chart:moveNoGroupsHint': 'Najpierw utwórz grupę, aby zorganizować wykresy.',
    'chart:deleteChartConfirm': 'Usunąć ten wykres?',
    'chart:deleteChartConfirmHint': 'Tej operacji nie można cofnąć.',
    'chart:deleteGroupConfirm': 'Usunąć tę grupę?',
    'chart:deleteGroupConfirmHint': 'Grupa oraz {count} wykres(ów) w niej zostaną trwale usunięte.',
    'chart:title': 'Tytuł',
    'chart:titlePlaceholder': 'np. Nowi użytkownicy dziennie',
    'chart:untitled': 'Bez tytułu',
    'chart:chartType': 'Typ wykresu',
    'chart:resource': 'Zasób',
    'chart:groupBy': 'Grupuj według',
    'chart:step': 'Krok',
    'chart:metric': 'Metryka',
    'chart:aggregateField': 'Pole agregacji',
    'chart:selectField': 'Wybierz pole…',
    'chart:saveChart': 'Zapisz wykres',
    'chart:typeLine': 'Liniowy',
    'chart:typeArea': 'Obszarowy',
    'chart:typeBar': 'Słupkowy',
    'chart:typePie': 'Kołowy',
    'chart:stepDay': 'Dzień',
    'chart:stepWeek': 'Tydzień',
    'chart:stepMonth': 'Miesiąc',
    'chart:stepYear': 'Rok',
    'chart:metricCount': 'Liczba',
    'chart:metricSum': 'Suma',
    'chart:metricAvg': 'Średnia',
    'chart:noData': 'Brak danych dla wybranego okresu',
    'chart:loadError': 'Nie udało się załadować danych wykresu',
    'chart:value': 'Wartość',
    'dashboard:vis': 'Wizualizacja',
    'dashboard:visKpi': 'KPI',
    'dashboard:visLine': 'Liniowy',
    'dashboard:visArea': 'Obszarowy',
    'dashboard:visBar': 'Słupkowy',
    'dashboard:visPie': 'Kołowy',
    'dashboard:metricCount': 'Liczba',
    'dashboard:metricSum': 'Suma',
    'dashboard:metricAvg': 'Średnia',
    'dashboard:metricMin': 'Min',
    'dashboard:metricMax': 'Maks',
    'dashboard:builder.range': 'Zakres czasu',
    'dashboard:builder.filters': 'Filtry',
    'dashboard:builder.filtersHint': 'Zawęź zbiór danych przed agregacją. Zaznacz filtr, aby pokazać go nad wykresem.',
    'dashboard:builder.quickFilterHint': 'Pokaż ten filtr nad wykresem na pulpicie.',
    'dashboard:builder.quickFilterToggle': 'Pokaż {field} jako szybki filtr',
    'dashboard:range.7d': '7d',
    'dashboard:range.30d': '30d',
    'dashboard:range.90d': '90d',
    'dashboard:range.1y': '1r',
    'dashboard:range.all': 'Wszystko',
    'dashboard:range.custom': 'Niestandardowy',
    'dashboard:widget.previousPeriod': 'vs. poprzedni okres',
    'dashboard:widget.deltaUp': '+{value} ({percent}%)',
    'dashboard:widget.deltaDown': '−{value} ({percent}%)',
    'dashboard:widget.deltaFlat': '{value} ({percent}%)',
    'dashboard:widget.shrink': 'Zmniejsz do połowy szerokości',
    'dashboard:widget.expand': 'Rozwiń na cały wiersz',
    'dashboard:widget.toggleSql': 'Pokaż SQL',
    'dashboard:widget.unsupported': 'Wykresy nie są jeszcze obsługiwane dla Twojej bazy danych.',
    'dashboard:widget.truncatedWarning': 'Wyświetlanie częściowych danych — zbyt wiele wierszy, aby zagregować cały zakres.',
    'dashboard:widget.showAll': 'Pokaż wszystko',
    'dashboard:widget.hideAll': 'Ukryj wszystko',
    'dashboard:seriesTotal': 'Łącznie',
    'dashboard:seriesOther': 'Inne',
    'dashboard:seriesNull': 'Puste',
    'dashboard:builder.dateField': 'Pole daty',
    'dashboard:builder.dateFieldHint': 'Oś X grupowana jest po tym polu daty.',
    'dashboard:builder.secondaryGroupBy': 'Podział',
    'dashboard:builder.noBreakdown': 'Pojedyncza seria',
    'dashboard:builder.topN': 'Maks. serii',
    'dashboard:builder.width': 'Szerokość',
    'dashboard:width.half': 'Połowa',
    'dashboard:width.full': 'Cały wiersz',
    'dashboard:builder.comparePrevious': 'Porównaj z poprzednim okresem',
    'dashboard:builder.comparePreviousHint': 'Nakłada poprzedni okres o tej samej długości jako linię przerywaną i pokazuje zmianę obok tytułu.',
    'dashboard:builder.comparePreviousDisabled': 'Niedostępne przy podziale.',
    'dashboard:builder.transform': 'Przekształcenie wartości',
    'dashboard:builder.transformHint': 'Stosowane do wartości przed wyświetleniem — np. podziel przez 100, aby pokazać centy jako dolary.',
    'dashboard:builder.transformAdd': 'Dodaj krok',
    'dashboard:builder.transformRemove': 'Usuń krok',
    'dashboard:builder.opDivide': 'Podziel przez',
    'dashboard:builder.opMultiply': 'Pomnóż przez',
    'dashboard:builder.opAdd': 'Dodaj',
    'dashboard:builder.opSubtract': 'Odejmij',
    'dashboard:builder.format': 'Format wartości',
    'dashboard:builder.formatStyle': 'Styl',
    'dashboard:builder.formatNumber': 'Liczba',
    'dashboard:builder.formatCurrency': 'Waluta',
    'dashboard:builder.formatPercent': 'Procent',
    'dashboard:builder.formatCurrencyCode': 'Kod waluty',
    'dashboard:builder.formatDecimals': 'Miejsca dziesiętne',
    'dashboard:builder.formatCompact': 'Liczby kompaktowe (12,5 tys.)',
    'dashboard:builder.formatPrefix': 'Prefiks',
    'dashboard:builder.formatSuffix': 'Sufiks',
    'dashboard:builder.color': 'Kolor serii',
    'dashboard:widget.previousSeries': '{label} (poprzedni okres)',
    'dashboard:widget.editColors': 'Edytuj kolory',
    'dashboard:widget.colorsTitle': 'Kolory serii',
    'dashboard:widget.colorCustom': 'Niestandardowy',
    'dashboard:widget.colorAuto': 'Automatyczny',
    'dashboard:widget.colorPick': 'Wybierz kolor',
    'dashboard:builder.tabData': 'Dane',
    'dashboard:builder.tabDisplay': 'Wyświetlanie',
    'dashboard:builder.tabFilters': 'Filtry',
    'dashboard:builder.filtersEmpty': 'Ten zasób nie ma pól do filtrowania.',
    'history:revisions': 'Rewizje',
    'history:noRevisions': 'Brak rewizji',
    'history:loadError': 'Nie udało się wczytać historii zmian',
    'history:revert': 'Przywróć',
    'history:confirmRevert': 'Przywrócić tę rewizję?',
    'history:revertSuccess': 'Rewizja przywrócona',
    'history:revertFailed': 'Nie udało się przywrócić rewizji',
    'history:unknownUser': 'Nieznany użytkownik',
    'history:changes': 'zmian',
    'history:compareTo': 'Porównaj z',
    'history:storedDiff': 'Diff zmiany',
    'history:op.create': 'Utworzono',
    'history:op.update': 'Zaktualizowano',
    'history:op.delete': 'Usunięto',
    'diff:added': 'Dodano',
    'diff:changed': 'Zmieniono',
    'diff:removed': 'Usunięto',
    'diff:before': 'Przed',
    'diff:after': 'Po',
    'diff:noChanges': 'Nie zapisano zmian pól',
    'audit:title': 'Aktywność',
    'audit:resource': 'Zasób',
    'audit:action': 'Akcja',
    'audit:recordId': 'ID rekordu',
    'audit:userId': 'ID użytkownika',
    'audit:allResources': 'Wszystkie zasoby',
    'audit:allActions': 'Wszystkie akcje',
    'audit:noEvents': 'Brak aktywności',
    'audit:records': 'rekordów',
    'audit:loadError': 'Nie udało się wczytać aktywności',
    'audit:by': 'autor: {user}',
    'audit:viewRecord': 'Otwórz rekord',
    'audit:viewChanges': 'Pokaż zmiany',
    'audit:hideChanges': 'Ukryj zmiany',
    'audit:noDiff': 'Szczegóły zmian niedostępne',
    'audit:loadDiffError': 'Nie udało się wczytać zmian',
    'audit:action.new': 'Rekord utworzony',
    'audit:action.edit': 'Rekord zaktualizowany',
    'audit:action.delete': 'Rekord usunięty',
    'audit:action.bulkDelete': 'Rekordy usunięte',
    'audit:action.login': 'Zalogowano',
    'audit:action.apiKeyCreate': 'Klucz API utworzony',
    'audit:action.apiKeyUpdate': 'Klucz API zaktualizowany',
    'audit:action.apiKeyDelete': 'Klucz API usunięty',
    'audit:virtualResource.auth': 'Uwierzytelnianie',
    'audit:virtualResource.apiKeys': 'Klucze API',
    'audit:prevPage': 'Poprzednia',
    'audit:nextPage': 'Następna',
    'audit:dateRangePlaceholder': 'Wybierz zakres dat',
    'keyValue:noMatches': 'Brak dopasowań — naciśnij Enter, aby zachować „{value}".',
    'aiAssistant:queue.cancel': 'Usuń z kolejki',
    'aiAssistant:title': 'Asystent AI',
    'aiAssistant:fab.label': 'Otwórz asystenta AI',
    'aiAssistant:fab.short': 'AI',
    'aiAssistant:description': 'Zadawaj pytania o rekordy, relacje, raporty i trendy w danych.',
    'aiAssistant:notConfigured.title': 'Asystent nie jest skonfigurowany',
    'aiAssistant:notConfigured.description': 'Dodaj klucz API OpenRouter w ustawieniach, aby włączyć asystenta AI w trybie tylko do odczytu.',
    'aiAssistant:notConfigured.openSettings': 'Otwórz ustawienia',
    'aiAssistant:tryAsking': 'Spróbuj zapytać:',
    'aiAssistant:tryAsking.example1': 'Którzy klienci mają najwięcej postów?',
    'aiAssistant:tryAsking.example2': 'Pokaż ostatnio utworzone rekordy dla zasobu.',
    'aiAssistant:tryAsking.example3': 'Wyjaśnij relacje między konkretnymi rekordami.',
    'aiAssistant:thinking': 'Myślę',
    'aiAssistant:thinkingProgress': 'Myślę ({progress}%)',
    'aiAssistant:input.placeholder': 'Zapytaj o swoje dane…',
    'aiAssistant:input.hint': 'Enter wysyła · Shift+Enter dodaje nowy wiersz',
    'aiAssistant:send': 'Wyślij wiadomość',
    'aiAssistant:newChat': 'Nowy czat',
    'aiAssistant:history': 'Historia czatów',
    'aiAssistant:history.empty': 'Brak wcześniejszych czatów',
    'aiAssistant:noText': 'Oto znalezione powiązane rekordy:',
    'aiAssistant:fallback.noToolResult': 'Żądanie zostało wykonane, ale model nie zwrócił odpowiedzi tekstowej. Doprecyzuj pytanie albo włącz logi debugowania, aby sprawdzić wynik narzędzia.',
    'aiAssistant:fallback.noRows': 'Nie znaleziono rekordów dla tego żądania.',
    'aiAssistant:fallback.rowsFound': 'Znalezione wiersze: {count}.',
    'aiAssistant:taskFailed': 'Zadanie asystenta AI nie powiodło się',
    'aiAssistant:settings.title': 'Asystent AI',
    'aiAssistant:settings.description': 'Skonfiguruj pływający widżet czatu AI, model i zachowanie asystenta po stronie serwera.',
    'aiAssistant:settings.enabled': 'Włączony',
    'aiAssistant:settings.disabled': 'Wyłączony',
    'aiAssistant:settings.configured': 'Skonfigurowano',
    'aiAssistant:settings.apiKeyRequired': 'Wymagany klucz API',
    'aiAssistant:settings.readOnly': 'Tylko do odczytu',
    'aiAssistant:settings.provider': 'Dostawca: {provider}',
    'aiAssistant:settings.enableLabel': 'Włącz asystenta',
    'aiAssistant:settings.enableHint': 'Kontroluje widoczność pływającego widżetu i punktu końcowego czatu.',
    'aiAssistant:settings.modelLabel': 'Model OpenRouter',
    'aiAssistant:settings.apiKeyLabel': 'Klucz API OpenRouter',
    'aiAssistant:settings.apiKeyHint': 'Pozostaw puste, aby zachować istniejący klucz zapisany na serwerze.',
    'aiAssistant:settings.systemPromptLabel': 'Nadpisanie promptu systemowego',
    'aiAssistant:settings.systemPromptPlaceholder': 'Opcjonalne instrukcje dla asystenta specyficzne dla projektu',
    'aiAssistant:settings.accessTitle': 'Model dostępu',
    'aiAssistant:settings.accessDescription': 'Obecny asystent jest ograniczony do inspekcji rekordów tylko do odczytu poprzez akcje zasobów administracyjnych.',
    'aiAssistant:settings.futureToolsReady': 'Przyszłe narzędzia gotowe',
    'aiAssistant:settings.save': 'Zapisz ustawienia',
    'aiAssistant:settings.saving': 'Zapisywanie…',
    'aiAssistant:settings.saved': 'Ustawienia asystenta AI zapisane',
    'aiAssistant:settings.empty': 'Brak dostępnych ustawień.',
    'aiFill:button': 'Wypełnij AI',
    'aiFill:dialogTitle': 'Wypełnij formularz ze zdjęcia',
    'aiFill:dialogDescription': 'Prześlij obraz — AI wyodrębni wartości i wypełni formularz.',
    'aiFill:fillButton': 'Rozpoznaj',
    'aiFill:processing': 'Rozpoznawanie obrazu\u2026',
    'aiFill:success': 'Wypełniono {count} pole/pól',
    'aiFill:errorNoFields': 'Ten zasób nie ma pól możliwych do wypełnienia przez AI.',
    'aiFill:errorGeneric': 'Wypełnianie przez AI nie powiodło się: {message}',
    'aiFill:noValues': 'AI nie mogła wyodrębnić żadnych wartości z tego obrazu.',
    'aiFill:applied': 'AI wypełniło {count} pole(i). Możesz cofnąć poniżej.',
    'filter:op.co': 'Zawiera',
    'filter:op.nco': 'Nie zawiera',
    'filter:op.sw': 'Zaczyna się od',
    'filter:op.ew': 'Kończy się na',
    'filter:op.eq': 'Jest równe',
    'filter:op.neq': 'Nie jest równe',
    'filter:op.empty': 'Jest puste',
    'filter:op.nempty': 'Nie jest puste',
    'filter:op.in': 'Jest jednym z',
    'filter:op.gt': 'Większe niż',
    'filter:op.lt': 'Mniejsze niż',
    'filter:op.between': 'Między',
    'filter:searchValues': 'Szukaj na liście…',
    'filter:selectAll': 'Zaznacz wszystko',
    'filter:noValues': 'Nie znaleziono wartości',
    'common:newRecord': 'Nowy {name}',
    'common:editRecord': 'Edytuj {name} #{id}',
    'common:themeLight': 'Jasny',
    'common:themeDark': 'Ciemny',
    'common:themeSystem': 'System',
    'common:ok': 'OK',
    'common:select': 'Wybierz…',
    'common:removeItem': 'Usuń {title}',
    'common:nSelectedAddMore': '{count} zaznaczonych — dodaj więcej',
    'common:pickRecords': 'Wybierz rekordy',
    'common:managePickRecords': 'Zarządzaj wyborem ({count})',
    'common:pickRecordsFrom': 'Wybierz z {name}',
    'common:draftRestored': 'Przywrócono niezapisany szkic',
    'common:undoDraftRestore': 'Cofnij',
    'wizard:stepOf': 'Krok {current} z {total}',
    'wizard:products.step1': 'Podstawowe informacje',
    'wizard:products.step2': 'Ceny',
    'wizard:products.step3': 'Media i tagi',
    'common:invalidValue': 'Nieprawidłowa wartość',
    'common:collapseSidebar': 'Zwiń pasek boczny',
    'common:expandSidebar': 'Rozwiń pasek boczny',
    'common:toggleSidebar': 'Przełącz pasek boczny',
    'common:sidebarTitle': 'Pasek boczny',
    'common:sidebarNavigation': 'Menu nawigacyjne',
    'cache:title': 'Pamięć podręczna',
    'cache:description': 'Stan pamięci podręcznej i wydajność zasobów na tej replice.',
    'cache:load.error': 'Nie udało się wczytać metryk pamięci podręcznej',
    'cache:load.retry': 'Spróbuj ponownie',
    'cache:reset.action': 'Wyzeruj metryki',
    'cache:reset.loading': 'Zerowanie metryk pamięci podręcznej…',
    'cache:reset.success': 'Metryki pamięci podręcznej wyzerowane',
    'cache:reset.error': 'Nie udało się wyzerować metryk',
    'cache:metric.hitRate': 'Współczynnik trafień',
    'cache:metric.requests': 'Odczyty pamięci',
    'cache:metric.avgCompute': 'Średni czas obliczeń',
    'cache:metric.errors': 'Błędy',
    'cache:unit.ms': '{value} ms',
    'cache:quarantine.title': 'Tagi w kwarantannie',
    'cache:quarantine.description': 'Te tagi omijają pamięć podręczną do pomyślnego unieważnienia.',
    'cache:invalidate.title': 'Unieważnij pamięć zasobu',
    'cache:invalidate.description': 'Usuwa listy i rekordy zasobu ze wszystkich skonfigurowanych replik.',
    'cache:invalidate.resource': 'Zasób',
    'cache:invalidate.action': 'Unieważnij pamięć',
    'cache:invalidate.loading': 'Unieważnianie pamięci…',
    'cache:invalidate.success': 'Pamięć zasobu unieważniona',
    'cache:invalidate.error': 'Nie udało się unieważnić pamięci zasobu',
    'cache:table.title': 'Metryki według przestrzeni nazw',
    'cache:table.empty': 'Nie zarejestrowano jeszcze aktywności pamięci podręcznej.',
    'cache:instance': 'Replika {id}',
    'cache:table.namespace': 'Przestrzeń nazw',
    'cache:table.resource': 'Zasób',
    'cache:table.hits': 'Trafienia',
    'cache:table.misses': 'Pudła',
    'cache:table.computes': 'Obliczenia',
    'cache:table.coalesced': 'Połączone',
    'cache:table.errors': 'Błędy',
  },
}
